import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Stepper.module.css";
import { inputValidations } from "./InputValidations";
import { inputValidationsMsgs } from "./InputValidations";

//this object tells us which inputs are at each step
const stepMapper = {
  '0' : ['inReceipt', 'hasLeft', 'isMcCloudEligible'],
  '1' : ['legacyScheme', 'dateOfBirth', 'dateJoinedScheme', 'dateOfPartRet', 'dateOfPartRet', 'salaryCurrent', 'salaryApril2015'],
  '2' : ['partTimeService'],
  '3' : ["partTimeServicePostPartRet", "salaryPostPartRet"]
}

const Stepper = ({ steps, setErrors, setMsgs, memberInfo }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();

  const areThereAnyErrors = () => {
    var errors = inputValidations(memberInfo)
    //only keep error messages that apply to our current step
    for (const key in errors) {
      if (!stepMapper[String(currentStep)].includes(key)) {
        delete errors[key];
      }
    }
    setErrors(errors)
    const noErrors = Object.values(errors).every(value => value === '')
    return noErrors
  }

  const areThereAnyMsgs = () => {
    var msgs = inputValidationsMsgs(memberInfo)
    //only keep error messages that apply to our current step
    for (const key in msgs) {
      if (!stepMapper[String(currentStep)].includes(key)) {
        delete msgs[key];
      }
    }
    setMsgs(msgs)
    const noMsgs = Object.values(msgs).every(value => value === '')
    return noMsgs
  }

  useEffect(() => {areThereAnyMsgs()}, [setMsgs, memberInfo, currentStep])

  var errors
  const handleNext = (event) => {
    event.preventDefault();
    // Validate the inputs before proceeding to the next step
    const noErrors = areThereAnyErrors()
    const noMsgs = areThereAnyMsgs()
    
    if (noErrors) {
      if (currentStep < steps.length - 1) {
        setCurrentStep((prev) => prev + 1);
      } else {
        navigate("/results");
      }
    }
  };

  const handleBack = () => {
    // now allowing user to go backwards even if they haven't filled in all inputs
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  return (
    <div
      role="region"
      aria-labelledby="stepper-heading"
      className={classes.region}
    >
      <h2 id="stepper-heading">
        Step {currentStep + 1} of {steps.length}
      </h2>
      <div aria-label="Progress" className={classes.progress}>
        {steps.map((_, index) => (
          <span
            key={index}
            style={{
              marginRight: 8,
              padding: "4px 8px",
              borderRadius: "50%",
              backgroundColor: index <= currentStep ? "var(--dark-purple)" : "var(--bg-highlight-color)",
              color: "white",
              display: "inline-block",
            }}
          >
            {index + 1}
          </span>
        ))}
      </div>
      <form onSubmit={handleNext}>
        {steps[currentStep]}
        <div style={{ marginTop: "20px" }}>
          <button
            type="button"
            onClick={handleBack}
            disabled={currentStep === 0}
            className={currentStep === 0 ? classes.buttonDisabled : ""}
          >
            Back
          </button>
          <button
            type="submit"
            className={classes.button}
          >
            {currentStep === steps.length - 1 ? "Finish" : "Next"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Stepper;
